import { pushEcommerceEvent } from '@utils/gtm';
import { useEffect, useRef } from 'react';

/**
 * 결제 화면 진입 시 begin_checkout 이벤트를 1회 발화한다.
 * ecommerce 가 준비되지 않았으면(undefined) 준비될 때까지 기다린다.
 */
function useBeginCheckoutOnce(ecommerce?: Record<string, unknown>) {
    const isSent = useRef(false);

    useEffect(() => {
        if (isSent.current || !ecommerce) return;
        isSent.current = true;
        pushEcommerceEvent('begin_checkout', ecommerce);
    }, [ecommerce]);
}

export default useBeginCheckoutOnce;
